module.exports = __webpack_public_path__ + "static/media/destination_1.275db202.jpg";